jQuery(document).ready(function ($) {
  $('.cm_testimonials_16 .slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    dots: false,
    focusOnSelect: false,
    infinite: true,
    variableWidth: false,
    rows: 0,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          variableWidth: false,
          arrows: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          variableWidth: false,
          arrows: false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          variableWidth: false,
          arrows: false

        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          variableWidth: false,
          dots: true,
          prevArrow: false,
          nextArrow: false,
          arrows: false
        }
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          variableWidth: false,
          dots: true,
          prevArrow: false,
          nextArrow: false,
          arrows: false
        }
      }
    ]

  });

  // next and previous button click
  $('.cm_testimonials_16 .slider').on('afterChange', function (event, slick, currentSlide) {
    //e.preventDefault();
    $src = $(this).find('.slick-cloned.slick-active .b-lazy:not(.b-loaded)');
    Drupal.blazy.init.load($src);
  });

  // .on('setPosition', function (event, slick) {
  //   slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  // });
});
